import {
  BestSellersCatalogDocument,
  BestSellersCatalogQuery,
} from "shared/catalog/BestSellersCatalog/best-sellers-catalog.query.generated";
import { initializeApollo } from "utils/with-apollo.utils";

import { catalogEntryDetails } from "../AvailableCatalog/available-catalog.helper";

export type BestSellersEntries = Awaited<
  ReturnType<typeof getBestSellerEntries>
>;
export const getBestSellerEntries = async () => {
  const apolloClient = initializeApollo();

  const { data } = await apolloClient.query<BestSellersCatalogQuery>({
    query: BestSellersCatalogDocument,
  });

  const isBlackFriday =
    data?.websiteSetting?.data?.attributes?.isBlackFriday ?? false;

  return data.bestSellersCatalog?.data?.attributes?.entries?.map((entry) =>
    catalogEntryDetails({
      catalogueEntry: entry,
      entryUpfronts: data?.upfronts,
      isBlackFriday,
    }),
  );
};
